import React from 'react';
//import { Link } from 'react-router-dom';
import styled from 'styled-components'; // package to define css class
//import $ from 'jquery'; // package to run jQuery
//import { Button } from 'bootstrap';
//import appstoreQRCode from '../images/qrcode/appstoreQRCode.png';
//import googleplayQRCode from '../images/qrcode/androidQRCode.png';
import Popup from 'reactjs-popup';
import './IOSModal.css';

const Col6 = styled.div`
    width: 100%;
    justify-content: center;
    vertical-align: top;
    display: inline-block;
`;

function IOSModal({ Ref }) {
    function toDownloadAppIOS() {
        window.open('https://apps.apple.com/hk/app/vivablee/id1551773278', "_blank");
        //window.location.href = 'https://apps.apple.com/hk/app/vivablee/id1551773278';
    }
    return (
        <div>
            <Popup
                ref={Ref}
                modal
                nested
                repositionOnResize
                contentStyle={{ maxWidth: '400px', borderRadius: '25px' }}
            >
                {close => (
                    <div className="imodal">
                        <button className="close" onClick={close}>
                            &times;
                            </button>
                        {/* <div className="header"> Download Vivablee </div> */}
                        <Col6>
                            {/* <h1><center>App Store</center></h1> */}
                            <img
                                style={{ width: '70%' }}
                                src={require('../images/qrcode/appstoreQRCode.png')}
                                className="center"
                                alt="appstore qrcode"
                            ></img>
                            <img
                                onClick={toDownloadAppIOS}
                                style={{ width: '60%', cursor: 'pointer' }}
                                //style={{ width: '170px', cursor: 'pointer' }}
                                src={require('../images/general/app_store.png')}
                                className="center"
                                alt="appstore download"
                            ></img>
                        </Col6>
                    </div>
                )}
            </Popup>
        </div>
    );
}

export default IOSModal;